module.exports = __webpack_public_path__ + "img/product_mobile.93b0941d.png";